import { render, staticRenderFns } from "./projectMain.vue?vue&type=template&id=0d94b70a&"
import script from "./projectMain.vue?vue&type=script&lang=js&"
export * from "./projectMain.vue?vue&type=script&lang=js&"
import style0 from "./projectMain.vue?vue&type=style&index=0&id=0d94b70a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports